// Components==============
import Input from 'components/UI/Form/Input';
import React from 'react';
import './AddInput.modules.scss';
import FormContext from 'utilities/FormContext';
import { useFormValues } from 'hooks/useFormValues';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus } from '@fortawesome/pro-regular-svg-icons';
import { TranslateType } from 'typings';
// =========================

export default function AddInput({
  onSubmit,
  placeholder,
  initial,
}: {
  onSubmit: (val: string) => void;
  placeholder: TranslateType;
  initial?: string;
}) {
  const { formValues, setFormValues, handleChange, errors } = useFormValues({
    value: initial || '',
  });

  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    onSubmit(formValues.value);
    setFormValues({ value: '' });
  }

  return (
    <form onSubmit={handleSubmit} styleName="wrapper">
      <FormContext
        onChange={handleChange}
        errors={errors}
        formValues={formValues}
      >
        <Input name="value" color="grey" placeholder={placeholder} />
        <button
          type={formValues.value ? 'submit' : 'button'}
          styleName={formValues.value ? 'submit' : ''}
        >
          <FontAwesomeIcon icon={faPlus} />
        </button>
      </FormContext>
    </form>
  );
}
